/**
 * @generated SignedSource<<d0d96109c1adafe7fc1dc1b30904f482>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersApplicationBase$data = {
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckIsPlusPage">;
  readonly " $fragmentType": "helpersApplicationBase";
};
export type helpersApplicationBase$key = {
  readonly " $data"?: helpersApplicationBase$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersApplicationBase">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersApplicationBase"
};

(node as any).hash = "960d7f53b40215aef323f25550ad26ab";

export default node;
